// extracted by mini-css-extract-plugin
export default {"selectDropdown":"Tabs_selectDropdown__eOWGo","dropdownTabContent":"Tabs_dropdownTabContent__+DBwt"};